import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('sitePage');
export const actions = helper.createActions('sitePage', actionTypes);
